import { quickSearchMobileScenarioA } from './quick-search-mobile-scenarios'
import {
  mobileScenarioA,
  mobileScenarioB,
  mobileScenarioC,
  mobileScenarioD,
  mobileScenarioE,
  mobileScenarioF,
  mobileScenarioG,
  mobileScenarioH,
  mobileScenarioI,
  mobileScenarioJ,
  mobileScenarioK,
  mobileScenarioL,
  mobileScenarioM,
  mobileScenarioN,
  mobileScenarioO,
  mobileScenarioP,
  mobileScenarioQ,
  mobileScenarioR,
} from './mobile-scenarios'
import {
  internetScenarioA,
  internetScenarioB,
  internetScenarioC,
  internetScenarioD,
  internetScenarioE,
  internetScenarioF,
  internetScenarioG,
  internetScenarioH,
  internetScenarioI,
} from './internet-scenarios'
import {
  mobileReviewsScenarioA,
  internetReviewsScenarioA,
  mobileReviewsScenarioB,
  internetReviewsScenarioB,
  mobileReviewsScenarioC,
} from './reviews-scenarios'
import { ticketScenarioA } from './ticket-scenarios'
import { adviseInternetScenarioA } from './advise-internet-scenarios'
import { mobileSearchEmailScenarioA } from './mobile-search-email-scenarios'
import {
  leadMobileScenarioA,
  leadInternetScenarioA,
  leadMobileScenarioB,
  leadInternetScenarioB,
  leadInternetScenarioC,
  leadMobileScenarioC,
  leadInternetMektelScenario,
} from './lead-scenarios'
import { checkAvailabilityScenarioA } from './check-availability-scenarios'
import {
  mobileAlertScenarioA,
  internetAlertScenarioA,
  internetFiberOpticAlertScenarioA,
  internetFiberOpticAlertScenarioB,
  internetAlertObserverScenarioA,
  mobileAlertObserverScenarioA,
  internetAlertScenarioB,
  mobileAlertScenarioB,
} from './alert-scenarios'
import { competitionInternetAlertScenarioA } from './competition-alert-scenarios'
import { newsletterScenarioA } from './newsletter-scenarios'
import { decisionScenarioA, decisionAlertScenarioA, decisionReviewContestScenarioA } from './decision-scenarios'
import { ScenarioType } from '../state/interfaces'
import { getCookie, setCookie } from './storage'
import { internetSpeedScenarioA } from './internet-speed-scenarios'
import { canadaVisitorScenarioA } from './canada-visitor-scenarios'
import { emailPageGoInternetScenarioA } from './email-page-go-scenarios'
import { emailPageGoMobileScenarioA } from './email-page-go-scenarios'
import { b2bScenarioA, b2bScenarioB } from './b2b-scenarios'
import { countryScenarioA } from './country-scenarios'
import {
  internetReviewsAwardScenarioB,
  mobileReviewsAwardScenarioB,
  mobileReviewsAwardScenarioC,
} from './reviews-award-scenarios'
import { emailCollectorScenarioA } from './email-collector-scenarios'
import { phoneSearchScenarioA, phoneSearchScenarioB } from './phone-search-scenarios'
import { governmentEmployeeScenarioA } from './government-employee-scenarios'
import { clientInfoInternetScenarioA } from './client-info-scenarios'

export const getAllScenarios = () => [
  mobileScenarioA,
  mobileScenarioB,
  mobileScenarioC,
  mobileScenarioD,
  mobileScenarioE,
  mobileScenarioF,
  mobileScenarioG,
  mobileScenarioH,
  mobileScenarioI,
  mobileScenarioJ,
  mobileScenarioK,
  mobileScenarioL,
  mobileScenarioM,
  mobileScenarioN,
  mobileScenarioO,
  mobileScenarioP,
  mobileScenarioQ,
  mobileScenarioR,
  internetScenarioA,
  internetScenarioB,
  internetScenarioC,
  internetScenarioD,
  internetScenarioE,
  internetScenarioF,
  internetScenarioG,
  internetScenarioH,
  internetScenarioI,
  mobileReviewsScenarioA,
  internetReviewsScenarioA,
  mobileReviewsScenarioB,
  mobileReviewsScenarioC,
  internetReviewsScenarioB,
  leadMobileScenarioA,
  leadInternetScenarioA,
  leadMobileScenarioB,
  leadInternetScenarioB,
  leadInternetScenarioC,
  leadInternetMektelScenario,
  leadMobileScenarioC,
  checkAvailabilityScenarioA,
  mobileAlertScenarioA,
  mobileAlertScenarioB,
  internetAlertScenarioA,
  internetAlertScenarioB,
  internetAlertObserverScenarioA,
  mobileAlertObserverScenarioA,
  internetFiberOpticAlertScenarioA,
  internetFiberOpticAlertScenarioB,
  competitionInternetAlertScenarioA,
  mobileSearchEmailScenarioA,
  adviseInternetScenarioA,
  newsletterScenarioA,
  decisionScenarioA,
  decisionAlertScenarioA,
  decisionReviewContestScenarioA,
  quickSearchMobileScenarioA,
  ticketScenarioA,
  internetSpeedScenarioA,
  canadaVisitorScenarioA,
  emailPageGoInternetScenarioA,
  emailPageGoMobileScenarioA,
  b2bScenarioA,
  b2bScenarioB,
  countryScenarioA,
  mobileReviewsAwardScenarioB,
  mobileReviewsAwardScenarioC,
  internetReviewsAwardScenarioB,
  emailCollectorScenarioA,
  phoneSearchScenarioA,
  phoneSearchScenarioB,
  governmentEmployeeScenarioA,
  clientInfoInternetScenarioA,
]

export const findScenarioById = (scenarioId: string) => {
  const providerName = getCookie('providerName')

  if (isMektelProvider(providerName) && scenarioId.match(/lead-internet/i)) {
    return getAllScenarios().find((scenario) => scenario.id === 'lead-internet-mektel')
  }

  if (isMektelScenarioId(scenarioId)) {
    return undefined
  }

  return getAllScenarios().find((scenario) => scenario.id === scenarioId && scenario.weight !== 0)
}

export const chooseScenarioId = (scenarioIdsToChooseFrom: Array<string>): string => {
  const scenarioIdCopies: Array<string> = []
  scenarioIdsToChooseFrom.forEach((scenarioId) => {
    const defaultWeight = 1
    const scenario = findScenarioById(scenarioId)

    if (!scenario) {
      return
    }

    const scenarioIdWeight = scenario.weight
    const scenarioRestrictions = scenario.restrictions || []
    const scenarioWeight = scenarioIdWeight || scenarioIdWeight === 0 ? scenarioIdWeight : defaultWeight
    const domain = window.location.hostname
    if (scenarioRestrictions.length > 0) {
      if (scenarioRestrictions.some((restriction) => domain.includes(restriction))) {
        for (let i = 0; i < scenarioWeight; i++) {
          scenarioIdCopies.push(scenarioId)
        }
      }
    } else {
      for (let i = 0; i < scenarioWeight; i++) {
        scenarioIdCopies.push(scenarioId)
      }
    }
  })
  return scenarioIdCopies[Math.floor(Math.random() * scenarioIdCopies.length)]
}

export const findPreviousUsedScenarioIdBasedOnType = (type: ScenarioType): string | null => {
  const providerName = getCookie('providerName')

  if (isMektelProvider(providerName) && type === ScenarioType.LEAD_INTERNET) {
    return 'lead-internet-mektel'
  }

  if (getCookie('scenarioRegistry')) {
    const scenarioRegistry = JSON.parse(getCookie('scenarioRegistry'))
    return scenarioRegistry[type] ? filterScenarioFromRegistry(scenarioRegistry[type]) : null
  }

  return null
}

const filterScenarioFromRegistry = (scenarioId: string): string | null => {
  if (scenarioId.match(/lead-internet/i)) {
    if (isMektelScenarioId(scenarioId)) {
      const providerName = getCookie('providerName')

      if (isMektelProvider(providerName)) {
        return scenarioId
      }
      return null
    }
  }
  return scenarioId
}

export const registerScenarioIdByType = (type: ScenarioType, id: string) => {
  const providerName = getCookie('providerName')

  if (isMektelProvider(providerName) && type === ScenarioType.LEAD_INTERNET) {
    return
  }

  let scenarioRegistry: Partial<Record<ScenarioType, string>> = {}
  if (getCookie('scenarioRegistry')) {
    scenarioRegistry = JSON.parse(getCookie('scenarioRegistry'))
    scenarioRegistry[type] = id
  } else {
    scenarioRegistry[type] = id
  }
  setCookie('scenarioRegistry', JSON.stringify(scenarioRegistry))
}

const isMektelProvider = (providerName: string | undefined): boolean => {
  return providerName?.toLocaleLowerCase() === 'mektel'
}

const isMektelScenarioId = (scenarioId: string): boolean => {
  return scenarioId === 'lead-internet-mektel'
}
